<template>
  <div
    id="navigation-slide"
    v-scroll-lock="isNavigationOpen"
    v-set-class-based-on-state="{ 'storeGetter': 'ui/isNavigationOpen', 'setThisClass': 'navigation-slide--is-open', 'applyHidden': true }"
    v-close-navigation
    class="navigation-slide">
    <div class="navigation-slide__top">
      <div class="navigation-slide__contact">
        <oie-base-button
          is-type="a"
          url="tel:+46304751010"
          text="0304-751010"
          css-classes="button--transparent"></oie-base-button>

        <oie-base-button
          is-type="a"
          url="mailto:order@oie.se"
          text="order@oie.se"
          css-classes="button--transparent"></oie-base-button>
      </div>

      <nav>
        <ul class="navigation-slide__nav-list">
          <li>
            <a href="/reservdelar/72f3b37d9c1c43bbb85016fbc32fb9da" class="navigational-item navigational-item--arrow navigational-item--dark-blue navigation-slide__link">
              Reservdelar
            </a>
          </li>

          <li>
            <a href="/reservdelar" class="navigational-item navigational-item--arrow navigational-item--dark-blue navigation-slide__link">
              Tillbehör
            </a>
          </li>

          <li>
            <a href="/reservdelar" class="navigational-item navigational-item--arrow navigational-item--dark-blue navigation-slide__link">
              Hydralik
            </a>
          </li>

          <li>
            <a href="/reservdelar" class="navigational-item navigational-item--arrow navigational-item--dark-blue navigation-slide__link">
              Kraftöverföring
            </a>
          </li>

          <li>
            <router-link to="/snabborder" class="navigational-item navigational-item--arrow navigational-item--dark-blue navigation-slide__link navigational-item--fastorder">
              <oie-use-svg svg="fastlist"></oie-use-svg>
              Snabborder
            </router-link>
          </li>
        </ul>
      </nav>
    </div>

    <div class="navigation-slide__bottom">
      <router-link to="/" class="navigational-item navigational-item--arrow navigational-item--gray navigational-item--dark-blue">
        <oie-use-svg svg="chat" class="navigation-item__icon"></oie-use-svg>
        Kundtjänst
      </router-link>

      <router-link v-if="!signedIn" to="/inloggning" class="navigational-item navigational-item--arrow navigational-item--gray navigational-item--dark-blue">
        <oie-use-svg svg="user" class="navigation-item__icon"></oie-use-svg>
        Logga in
      </router-link>

      <oie-the-navigation-accordion-shell v-if="signedIn" :open-on-init="false">
        <template slot="toggler">
          <oie-use-svg svg="user" class="navigation-item__icon"></oie-use-svg>
          Mina sidor
        </template>

        <template slot="content">
          <router-link to="/mitt-konto" class="navigational-item navigational-item--arrow navigational-item--gray navigational-item--dark-blue">
            <oie-use-svg svg="chat" class="navigation-item__icon"></oie-use-svg>
            Mitt konto
          </router-link>

          <router-link to="/order-historik" class="navigational-item navigational-item--arrow navigational-item--gray navigational-item--dark-blue">
            <oie-use-svg svg="chat" class="navigation-item__icon"></oie-use-svg>
            Orderhistorik
          </router-link>
        </template>
      </oie-the-navigation-accordion-shell>

      <oie-navigation-market-selector
        referrer-url="/sv/"
        :available-markets="[{&quot;disabled&quot;:false,&quot;group&quot;:null,&quot;selected&quot;:true,&quot;text&quot;:&quot;Sverige&quot;,&quot;value&quot;:&quot;se&quot;,&quot;languages&quot;:[{&quot;value&quot;:&quot;sv&quot;,&quot;text&quot;:&quot;Svenska&quot;,&quot;default&quot;:true}]}]">
      </oie-navigation-market-selector>

      <button v-if="signedIn" class="navigational-item navigational-item--gray navigational-item--dark-blue">
        <oie-use-svg svg="user" class="navigation-item__icon"></oie-use-svg>
        Logga ut
      </button>

      <oie-vat-switch is-for="vat-switch"></oie-vat-switch>

      <!-- <oie-list-price-switch></oie-list-price-switch> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    signedIn: true
  }),
  computed: {
    ...mapGetters('ui', ['isNavigationOpen'])
  }
}
</script>
